/* =====================
 *  刪除Array裡面的某個(或某區段)的元素
 *  @author Alan
 * ===================== */
Array.prototype.remove = function(from, to) {
  var rest = this.slice((to || from) + 1 || this.length);
  this.length = from < 0 ? this.length + from : from;
  return this.push.apply(this, rest);
};

/* =====================
 *  加某個item移動至某個位置
 *  @author Alan
 * ===================== */
Array.prototype.move = function(old_index, new_index) {
  if (new_index >= this.length) {
    var k = new_index - this.length;
    while ((k--) + 1) {
      this.push(undefined);
    }
  }
  this.splice(new_index, 0, this.splice(old_index, 1)[0]);
  return this; // for testing purposes
};

/* =====================
 *  加某個item加入到Array的某個位置
 *  @author Alan
 * ===================== */
Array.prototype.insert = function(index, item) {
  this.splice(index, 0, item);
};

/* =====================
 * 讓使用者在輸入的停止的時候才執行某個動作
 * ===================== */
function throttle(fn, delay) {
  var timer = null;
  return function() {
    var context = this,
      args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function() {
      fn.apply(context, args);
    }, delay);
  };
}

/* =====================
 * 鎖定瀏覽器視窗的捲軸列，強制讓捲軸列消失並且無法移動
 * ===================== */
function lockWindowScroll(containerID)
{
  var html = jQuery('html'),
      scrollPosition = [self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft, self.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop];

  if(html.data('isScollLocked')){
    return;
  }

  html.data('scroll-position', scrollPosition);

  var container = $('#' + containerID);
  if(container.length == 0){
    html.data('previous-overflow-x', html.css('overflow-x'));
    html.data('previous-overflow-y', html.css('overflow-y'));
    html.css('overflow-x', 'hidden');
    html.css('overflow-y', 'hidden');
    window.scrollTo(scrollPosition[0], scrollPosition[1]);
  } else{
    container.data('previous-top', container.css('top'));
    container.data('previous-position', container.css('position'));
    container.css({
      'position': 'fixed',
      'top': -scrollPosition[1]
    });
  }

  html.data('isScollLocked', true);
}

/* =====================
 * 解除瀏覽器視窗的捲軸列鎖定
 * ===================== */
function unlockWindowScroll(containerID)
{
  var html = jQuery('html'),
      scrollPosition = html.data('scroll-position');

  if(!html.data('isScollLocked')){
    return;
  }

  var container = $('#' + containerID);
  if(container.length == 0){
    html.css('overflow-x', html.data('previous-overflow-x'));
    html.css('overflow-y', html.data('previous-overflow-y'));
  } else {
    container.css({
      'top': container.data('previous-top'),
      'position': container.data('previous-position')
    });
  }

  window.scrollTo(scrollPosition[0], scrollPosition[1]);
  html.data('isScollLocked', false);
}

/* =====================
 * 檢查是否為url格式
 * ===================== */
function isUrl(url) {
  return (/^([a-z]([a-z]|\d|\+|-|\.)*):(\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?((\[(|(v[\da-f]{1,}\.(([a-z]|\d|-|\.|_|~)|[!\$&'\(\)\*\+,;=]|:)+))\])|((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=])*)(:\d*)?)(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*|(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)|((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)|((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)){0})(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(url));
};

/* =====================
 * 將沒有http://的url加上http://
 * ===================== */
function addhttp(url) {
  if (!/^(?:f|ht)tps?\:\/\//.test(url)) {
    url = "http://" + url;
  }
  return url;
}

/* =====================
 * 檢查是否為email格式
 * ===================== */
function isEmail(email) {
  return (/^[^@^\s]+@[^\.@^\s]+(\.[^\.@^\s]+)+$/.test(email));
}

/* =====================
 * 檢查是否為手機格式
 * ===================== */
function isPhone(phone) {
  return (/^[0-9\-()+]{3,20}$/.test(phone));
}

/* =====================
 * 檢查是否為台灣統編格式 (新舊制任何一種)
 * ===================== */
function isTaxIDNumber(taxIDNumber){
  return checkOldTaxNumber(taxIDNumber) || checkNewTaxNumber(taxIDNumber);
}

/* =====================
 * 檢查是否為台灣統編格式
 * ===================== */
function checkOldTaxNumber(taxIDNumber) {
  var reg = /^\d{8}$/;

  // Step 1: 共八位，全部為數字型態
  if(!reg.test(taxIDNumber)) {
    return false;
  }

  // Step 2: 將統編每位數乘以一個固定值
  // 固定值為 1, 2, 1, 2, 1, 2, 4, 1
  //
  // 例: 統一編號為 12986518
  //
  //   1   2   9   8   6   5   1   8
  // x 1   2   1   2   1   2   4   1
  // ================================
  //   1   4   9  16   6  10   4   8

  var multiplyList = [1, 2, 1, 2, 1, 2, 4, 1];
  var taxIDList = taxIDNumber.split('');

  // Step 3: 將所得值取出十位數及個位數，並獨立加總，最後將兩個值再相加
  //
  // 例: 統一編號為 12986518
  //
  //  十位數 個位數
  //    0     1
  //    0     4
  //    0     9
  //    1     6
  //    0     6
  //    1     0
  //    0     4
  // +  0     8
  // =============
  //    2    38  -> 2 + 38 = 40

  var sum = 0;

  for(var i = 0; i < multiplyList.length; i++) {
    var mult = multiplyList[i];
    var id = Number(taxIDList[i]);
    var quotient = mult * id;
    var ten_digits = Math.floor(quotient / 10);
    var digits = quotient - ten_digits * 10;
    var quo_sum = ten_digits + digits;
    sum += quo_sum;
  }

  // Step 4: 判斷結果
  // 最後的加總值, 被 10 整除就為正確
  // 若上述演算不正確並且 統編第 7 位為 7 得話, 總值再加上 1 被 10 整除也為正確

  var remainder = sum % 10;

  if(remainder === 0) {
    return true;
  } else if(Number(taxIDList[6]) === 7 && remainder === 9) {
    return true;
  } else {
    return false;
  }
}

/**
 * 檢查統一編號是否正確
 * @param {string} taxNumber - 統一編號 (8 位數字)
 * @returns {boolean} - true 表示格式正確, false 表示格式錯誤
 */
function checkNewTaxNumber(taxNumber) {

  // 檢查字元是否符合規則
  const regex = /^[0-9]{8}$/;

  // 統一編號 邏輯乘數
  const logicMultipliers = [1, 2, 1, 2, 1, 2, 4, 1];

  // 計算陣列總和
  const sum = (_taxnumber) => {
    const initialValue = 0;
    const sumWithInitial = _taxnumber.reduce(
        (accumulator, currentValue) => Number(accumulator) + Number(currentValue),
        initialValue,
    );
    return sumWithInitial
  }

  if (!taxNumber) {
    return false;
  }

  // 1. 檢查是否為 8 位數字
  if (taxNumber.length !== 8 || !regex.test(taxNumber)) {
    return false;
  }

  let logicProductArr = []
  let logicProduct = 0;
  // 通一編號倒數第二位為7時，乘積之和最後第二位數取0或1均可，其中之一和能被5整除，則符合統編邏輯
  if (taxNumber[6] == "7") {
    for (let i = 0; i < taxNumber.length; i++) {
      if (i != 6) {
        logicProductArr.push(parseInt(taxNumber[i]) * logicMultipliers[i])
      }
    }
  } else {
    for (let i = 0; i < taxNumber.length; i++) {
      logicProductArr.push(parseInt(taxNumber[i]) * logicMultipliers[i]);
    }
  }

  for (const item of logicProductArr) {
    logicProduct += sum((item.toString()).split(''));
  }

  if (taxNumber[6] === '7' && (logicProduct % 5 === 0 || (logicProduct + 1) % 5 === 0)) {
    return true;
  } else if (logicProduct % 5 === 0) {
    return true;
  }

  return false;
}

/* =====================
 * 檢查是否為手機載具條碼
 * ===================== */
function isMobilePhoneCarrierID(mobilePhoneCarrierID) {
  return (/^\/[0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ+-.]{7}$/.test(mobilePhoneCarrierID));
}

/* =====================
 * 檢查是否為自然人憑證條碼
 * ===================== */
function isDigitalCitizenCarrierID(digitalCitizenCarrierID) {
  return (/^[ABCDEFGHIJKLMNOPQRSTUVWXYZ]{2}[0123456789]{14}$/.test(digitalCitizenCarrierID));
}


/* =====================
 * 取得url的變數
 * ===================== */
function getURLParameter(name) {
  var param = decodeURI(
    (RegExp(name + '=' + '(.+?)(&|$)').exec(location.search) || [, null])[1]
  )

  if (param == "null") {
    param = undefined;
  };

  return param;
}

/* =====================
 * Format Number
 * ===================== */
function formatNumber(number, decimal)
{
  if(window.isNaN(decimal)){
    decimal = 0;
  }

  var number = number.toFixed(decimal) + '';
  var x = number.split('.');
  var x1 = x[0];
  var x2 = x.length > 1 ? '.' + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + ',' + '$2');
  }
  return x1 + x2;
}

function throttleEventWithRAFEvent(origEventName, newEventName, eventObj) {
  var eventObj = eventObj || window;
  var running = false;
  var func = function() {
    if (running) {
      return;
    }
    running = true;
    requestAnimationFrame(function() {
      eventObj.dispatchEvent(new CustomEvent(newEventName));
      running = false;
    });
  };
  return eventObj.addEventListener(origEventName, func);
};
throttleEventWithRAFEvent('resize', 'optimizedResize');
throttleEventWithRAFEvent('scroll', 'optimizedScroll');

/* =====================
 * 將數字中dash去除
 * ===================== */
function removeDashInNumber(number) {

  if(typeof number == 'string') {
    return number.replace(/-/g, '');
  }

  return number;
}

function shallowCopy(object) {

    if(object === undefined) {
        return undefined;
    }

    return JSON.parse(JSON.stringify(object))
}

// --------------------------------
// Ctype 常數
// --------------------------------
var CtypeToInt = {
  CTYPE_IMAGE: 1,
  CTYPE_VIDEO: 2,
  CTYPE_TEXT: 3,
};

// --------------------------------
// AD Block 常數
// --------------------------------
var ADblockToInt = {
  ADBLOCK_INDEX_ROTION: 1, // 首頁廣告
  ADBLOCK_CLASSIFIED: 2, // 分類廣告
  ADBLOCK_SEARCHING_TEXT: 3, // 搜尋文字廣告
  ADBLOCK_MOBILE_INDEX_ROTION: 4, // 手機版首頁廣告
  ADBLOCK_HOME_BLOCK_AD: 5, // 首頁區塊廣告
};

var OrderDeliveryType = {
   SELF: 0, // 自行取貨
   HOME: 1, // 宅配
   TEXI: 2, // 計程車送件
}

var Paytype_SinopacATM = 1;
var Paytype_SinopacCreditCard = 2;
var Paytype_ManualCash = 3;
var Paytype_Point = 4;
var Paytype_OutwardRemittance = 5;
var Paytype_Spgateway_Cvs = 6;
var Paytype_Monthly = 21;

var default_loveCodeList = [
  {label: '社團法人世界和平會 (000)', name: '社團法人世界和平會', code: '000'},
  {label: '財團法人喜憨兒社會福利基金會 (88432)', name: '財團法人喜憨兒社會福利基金會', code: '88432'},
  {label: '財團法人中華民國兒童癌症基金會 (88888)', name: '財團法人中華民國兒童癌症基金會', code: '88888'},
  {label: '財團法人陽光社會福利基金會 (13579)', name: '財團法人陽光社會福利基金會', code: '13579'},
  {label: '財團法人愛盲基金會 (5880)', name: '財團法人愛盲基金會', code: '5880'},
  {label: '財團法人勵馨社會福利事業基金會 (9118595)', name: '財團法人勵馨社會福利事業基金會', code: '9118595'},
  {label: '財團法人創世社會福利基金會 (919)', name: '財團法人創世社會福利基金會', code: '919'},
  {label: '財團法人台灣兒童暨家庭扶助基金會 (8585)', name: '財團法人台灣兒童暨家庭扶助基金會', code: '8585'},
  {label: '財團法人伊甸社會福利基金會 (25885)', name: '財團法人伊甸社會福利基金會', code: '25885'},
  {label: '社團法人中華民國自閉症總會 (1577)', name: '社團法人中華民國自閉症總會', code: '1577'},
  {label: '其他', name: '其他', code: '-1'},
]

var windowlocation = window.location.toString();
var DOMAIN = window.location.host.indexOf('www') !== -1 ? "www.inifec.com.tw" : 'inifec.com.tw';
var ServerID = "release";
var SINOPAC_ShopNO = "AA0085";
var PAYMENT_URL = "https://ecapi.sinopac.com/SinoPacWebCard/Pages/PageRedirect.aspx";
var CMS_URL = "http://cms.inifec.com.tw";
var SECURE = "https://";

// ── 大檔上傳分流（docs/adr/0015）──
// CDN 擋大 request body（Cloudflare Free 上限 100MB），超過門檻的檔案改打一個不經 CDN 的網域。
// 空字串 = 關閉，全部打同源 /UploadServlet。某個網域要開時，後端該環境 inifec.prop 的
// SessionCookieDomain 也必須一起設，否則分流網域收不到 session、一律回 noLogin。
var UPLOAD_DIRECT_URL = "";
var UPLOAD_DIRECT_THRESHOLD_MB = 90; // 超過才分流；門檻要低於 CDN 上限、留 multipart 開銷的餘裕
var UPLOAD_MAX_MB = 1024;            // 單檔上限；分流網域 nginx 的 client_max_body_size 必須略大於它

// 目前使用測試資料
if(windowlocation.toLowerCase().indexOf("localhost") !== -1) {
  // 不寫死 port：本機 8080 可能被別的專案佔用，容器改 publish 到別的 port 時（例如 18080），
  // 寫死 8080 會讓 API 靜默打到別人的服務、頁面空白。URLRoot（信件連結）仍是 8080，不受此影響。
  DOMAIN = window.location.host;
  ServerID = "local";
  SINOPAC_ShopNO = "AB0105";
  PAYMENT_URL = "http://ecapisandbox.sinopac.com/SinoPacWebCard/Pages/PageRedirect.aspx";
  CMS_URL = "http://localhost:3000";
  SECURE = "http://";
  // 本機測大檔分流：ctx_local 設 SessionCookieDomain=inif.localhost，從 http://www.inif.localhost:<port>
  // 進站（Chrome / Firefox 會把 *.localhost 自動解析到本機，不用改 /etc/hosts；網址含 localhost 所以
  // 仍命中這個分支），再打開下面兩行（門檻調小才測得到）。不要 commit 打開的狀態。
  // UPLOAD_DIRECT_URL = "http://upload.inif.localhost:" + window.location.port;
  // UPLOAD_DIRECT_THRESHOLD_MB = 1;
} else if (windowlocation.toLowerCase().indexOf("m.inifec.taocart.") !== -1) {
  DOMAIN = "m.inifec.taocart.com";
  ServerID = "beta";
  SINOPAC_ShopNO = "AB0105";
  PAYMENT_URL = "http://ecapisandbox.sinopac.com/SinoPacWebCard/Pages/PageRedirect.aspx";
  CMS_URL = "http://localhost:3000";
  SECURE = "https://";
} else if (windowlocation.toLowerCase().indexOf("inifec.taocart.") !== -1) {
  DOMAIN = "inifec.taocart.com";
  ServerID = "beta";
  SINOPAC_ShopNO = "AB0105";
  PAYMENT_URL = "http://ecapisandbox.sinopac.com/SinoPacWebCard/Pages/PageRedirect.aspx";
  CMS_URL = "http://localhost:3000";
  SECURE = "https://";
} else if (windowlocation.toLowerCase().indexOf("beta-m.inif.com.tw") !== -1) {
  // beta 驗收站的手機版。**必須排在下面那條 m.inif.com.tw 之前** —— 判斷是 indexOf
  // 依序比對，而 "beta-m.inif.com.tw" 從第 5 個字元起整個包含了 "m.inif.com.tw"，
  // 順序反了就會命中正式站那條：DOMAIN 變成 m.inif.com.tw、ServerID 變成 release
  //（IS_RELEASE=true → GA / FB Pixel / Ads 全開，驗收流量打進正式報表），
  // 而且完全沒有錯誤訊息。連字號版本沒有解除這個約束，只是換了字面。
  // 手機由 js/check.js 從 beta.inif.com.tw 改寫 hostname 過來。
  DOMAIN = "beta-m.inif.com.tw";
  ServerID = "beta"; // 不送 GA / FB Pixel / Ads，避免驗收流量污染正式報表與轉換回報
  SINOPAC_ShopNO = "AB0105";
  PAYMENT_URL = "http://ecapisandbox.sinopac.com/SinoPacWebCard/Pages/PageRedirect.aspx";
  CMS_URL = "http://localhost:3000";
  SECURE = window.location.protocol + "//"; // beta 目前只有 http，寫死 https 會再壞一次
} else if (windowlocation.toLowerCase().indexOf("m.inif.com.tw") !== -1) {
  DOMAIN = "m.inif.com.tw";
  ServerID = "release";
  SINOPAC_ShopNO = "AB0105";
  PAYMENT_URL = "http://ecapisandbox.sinopac.com/SinoPacWebCard/Pages/PageRedirect.aspx";
  CMS_URL = "http://localhost:3000";
  // SECURE = "https://";
  SECURE = window.location.protocol + "//";
} else if (windowlocation.toLowerCase().indexOf("www.inif.com.tw") !== -1) {
  DOMAIN = "www.inif.com.tw";
  ServerID = "release";
  SINOPAC_ShopNO = "AB0105";
  PAYMENT_URL = "http://ecapisandbox.sinopac.com/SinoPacWebCard/Pages/PageRedirect.aspx";
  CMS_URL = "http://localhost:3000";
  // SECURE = "https://";
  SECURE = window.location.protocol + "//";
  // 正式站前面是 Cloudflare Free（request body 上限 100MB）；upload 子網域是 DNS-only，直連 origin
  UPLOAD_DIRECT_URL = SECURE + "upload.inif.com.tw";
} else if (windowlocation.toLowerCase().indexOf("beta.inif.com.tw") !== -1) {
  // 正式站切換前的驗收站。這條分支缺席時不會有任何錯誤訊息 —— 會落到檔頭的預設值
  // （DOMAIN = "inifec.com.tw"、SECURE = "https://"），而那個舊網域的 https 已經連不上，
  // 於是 45 支檔案組出來的 API URL 全部跨網域打進一個死位址，全站靜默空白。
  DOMAIN = "beta.inif.com.tw";
  ServerID = "beta"; // 不送 GA / FB Pixel / Ads，避免驗收流量污染正式報表與轉換回報
  SINOPAC_ShopNO = "AB0105";
  PAYMENT_URL = "http://ecapisandbox.sinopac.com/SinoPacWebCard/Pages/PageRedirect.aspx";
  CMS_URL = "http://localhost:3000";
  SECURE = window.location.protocol + "//"; // beta 目前只有 http，寫死 https 會再壞一次
}


var INIFEC_URL = "http://" + DOMAIN;
var SECURE_INIFEC_URL = SECURE + DOMAIN;

// 決定 /UploadServlet 要打哪裡：有設 UPLOAD_DIRECT_URL 且檔案超過門檻才走分流網域，否則用 defaultUrl
function getUploadServletUrl(defaultUrl, file) {
  if (UPLOAD_DIRECT_URL && file && file.size > UPLOAD_DIRECT_THRESHOLD_MB * 1024 * 1024) {
    return UPLOAD_DIRECT_URL + "/UploadServlet";
  }
  return defaultUrl;
}

// 單檔超過 UPLOAD_MAX_MB 時跳提示並回傳 false
function checkUploadFileSize(file) {
  if (file && file.size > UPLOAD_MAX_MB * 1024 * 1024) {
    var limit = UPLOAD_MAX_MB >= 1024 ? (UPLOAD_MAX_MB / 1024) + "GB" : UPLOAD_MAX_MB + "MB";
    alert("檔案「" + file.name + "」超過 " + limit + " 上限，請壓縮或分割後再上傳。");
    return false;
  }
  return true;
}

// 分流到其他網域的大檔，先送一個不帶檔案的請求（op=checkUploadLogin），確認憑證、CORS、跨子網域 cookie、
// 登入都正常才開始傳；否則要等幾百 MB 整個傳完，servlet 才有機會檢查登入（docs/adr/0015）。
// 沒有分流（url === defaultUrl，同源）時直接放行。targetOp 是接下來要用的上傳 op。
// 成功時 resolve；失敗時 reject 跟上傳失敗相同形狀的錯誤物件（{code, message}）。
function precheckUploadServlet($http, $q, url, defaultUrl, targetOp) {
  if (url === defaultUrl) {
    return $q.when();
  }

  var fd = new FormData();
  fd.append('op', 'checkUploadLogin');
  fd.append('targetop', targetOp);

  return $http.post(url, fd, {
    transformRequest: angular.identity,
    headers: {'Content-Type': undefined},
    withCredentials: true
  }).then(function(res) {
    if (res.data && res.data.error) {
      return $q.reject(res.data.error);
    }
  }, function(res) {
    return $q.reject(res.data || {code: 'error.upload.precheckFailed'});
  });
}
var S3_CDN_DOMAIN = "//www.inifec.com.tw/"

if(window.location.protocol == "https:") {
  CMS_URL = CMS_URL.replace('http://', 'https://');
}

// ── bundler 契約：把本檔的頂層宣告明確發布到 window ──
//
// 以下識別字被本 app 的其他 script 以「裸識別字」讀取。concat build 把所有檔案串成
// 一份、共用同一個 function scope，所以裸讀取成立；換成 module bundler 之後每支檔案
// 是自己的 module scope，這些宣告會被改名（撞名時加後綴），沒被本檔用到的還會被整個
// tree-shake 掉 —— 讀取端於是變成未解析的全域查找，執行到才 ReferenceError，而 build
// 與註冊比對都不會有任何訊號（admin 的 checkActionErrorIsNoLogin 實測 289 次呼叫、
// 0 次宣告）。
//
// 位置必須在上面 if-chain 的重新賦值之後，抄到的才是最終值。
// 新增頂層宣告時這裡要一起加 —— build/check-app-globals.js 會斷言兩邊一致。

window.throttle = throttle;
window.lockWindowScroll = lockWindowScroll;
window.unlockWindowScroll = unlockWindowScroll;
window.isUrl = isUrl;
window.addhttp = addhttp;
window.isEmail = isEmail;
window.isPhone = isPhone;
window.isTaxIDNumber = isTaxIDNumber;
window.checkOldTaxNumber = checkOldTaxNumber;
window.checkNewTaxNumber = checkNewTaxNumber;
window.isMobilePhoneCarrierID = isMobilePhoneCarrierID;
window.isDigitalCitizenCarrierID = isDigitalCitizenCarrierID;
window.getURLParameter = getURLParameter;
window.formatNumber = formatNumber;
window.throttleEventWithRAFEvent = throttleEventWithRAFEvent;
window.removeDashInNumber = removeDashInNumber;
window.shallowCopy = shallowCopy;
window.CtypeToInt = CtypeToInt;
window.ADblockToInt = ADblockToInt;
window.OrderDeliveryType = OrderDeliveryType;
window.Paytype_SinopacATM = Paytype_SinopacATM;
window.Paytype_SinopacCreditCard = Paytype_SinopacCreditCard;
window.Paytype_ManualCash = Paytype_ManualCash;
window.Paytype_Point = Paytype_Point;
window.Paytype_OutwardRemittance = Paytype_OutwardRemittance;
window.Paytype_Spgateway_Cvs = Paytype_Spgateway_Cvs;
window.Paytype_Monthly = Paytype_Monthly;
window.default_loveCodeList = default_loveCodeList;
window.windowlocation = windowlocation;
window.DOMAIN = DOMAIN;
window.ServerID = ServerID;
window.SINOPAC_ShopNO = SINOPAC_ShopNO;
window.PAYMENT_URL = PAYMENT_URL;
window.CMS_URL = CMS_URL;
window.SECURE = SECURE;
window.INIFEC_URL = INIFEC_URL;
window.SECURE_INIFEC_URL = SECURE_INIFEC_URL;
window.UPLOAD_DIRECT_URL = UPLOAD_DIRECT_URL;
window.UPLOAD_DIRECT_THRESHOLD_MB = UPLOAD_DIRECT_THRESHOLD_MB;
window.UPLOAD_MAX_MB = UPLOAD_MAX_MB;
window.getUploadServletUrl = getUploadServletUrl;
window.checkUploadFileSize = checkUploadFileSize;
window.precheckUploadServlet = precheckUploadServlet;
window.S3_CDN_DOMAIN = S3_CDN_DOMAIN;
